import { Box, Stack } from 'braid-design-system';
import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import type { AppState } from 'src/types/appState';
import type { SuggestedSalary } from 'src/types/salaryTypes';

import { PayRangeBar } from './components/Bar';
import { PayRangeLabel } from './components/Label';

export const PayRangeRecommendation = ({
  suggestedSalary,
}: {
  suggestedSalary: SuggestedSalary;
}) => {
  const { maxSalaryValue, minSalaryValue, payType } = useSelector(
    (state: AppState) => ({
      maxSalaryValue: state.formData.maxSalary,
      minSalaryValue: state.formData.minSalary,
      payType: state.formData.payType,
    }),
    shallowEqual,
  );

  return (
    <Box padding="large" style={{ backgroundColor: '#f5f6f8' }}>
      <Stack space="medium">
        <PayRangeLabel
          suggestedSalary={{ ...suggestedSalary }}
          payType={payType}
        />
        <PayRangeBar
          suggestedSalary={suggestedSalary}
          userInputMinMax={{
            minInput: minSalaryValue,
            maxInput: maxSalaryValue,
          }}
        />
      </Stack>
    </Box>
  );
};
